/* eslint-disable @typescript-eslint/no-explicit-any */
const DataUtils = {
  convertData(data: any) {
    const newData: any[] = [];

    const convertMap = data.convertData,
      compactData = data.compactData;

    if (convertMap && Object.keys(convertMap).length !== 0) {
      compactData.forEach((item: any) => {
        const obj: any = {};
        for (const key in convertMap) {
          obj[key] = item[convertMap[key]];
        }
        newData.push(obj);
      });
      return newData;
    } else {
      return data.data;
    }
  },
};
export default DataUtils;
